import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container, Paper, Box } from '@mui/material';
import PaymentTabs from './PaymentTabs';

export default function PaymentSettingsLayout() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <div className="page-header">
        <h1>Payment Settings</h1>
        <p>Configure payment gateways, POS and view reports</p>
      </div>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <PaymentTabs />
        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Paper>
    </Container>
  );
}
